import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export const ManualRefundEngagementMeetingProposal = createAsyncThunk(
    'engagementMeetings/manualRefundMeetingProposal',
    async (
        {
            engagementId,
            meetingProposalId,
            amount,
        }: { engagementId: number; meetingProposalId: string; amount: number },
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        const response = await axios.post(
            `/api/Marketplace/Engagements/${engagementId}/MeetingScheduling/${meetingProposalId}/ManualRefund`,
            amount,
            { headers: { 'Content-Type': 'application/json' } }
        );

        if (response.status !== 200 && response.status !== 204) {
            createNotification('Could not process refund at the moment.', 'error');
            throw new Error('Failed to process refund');
        }

        createNotification('Refund processed successfully.', 'success');
        return { engagementId, meetingProposalId, amount };
    }
);
